import $ from 'jquery';

import colors from '../../lib/colors'

export default function(disabled){

  if(disabled){
    var color = colors.grey.s_500
  } else {
    var color = colors.white
  }

  var div =
    $('<textarea>')
    .attr({
      readonly: disabled,
    })
    .css({
      display: 'inline-block',
      verticalAlign: 'top',
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      appearance: 'none',
      backgroundColor: colors.grey.s_900,
      border: 'none',
      borderRadius: 0,
      boxShadow: 'none',
      boxSizing: 'inherit',
      padding: '8px',
      color: color,
      fontFamily: 'Helvetica, sans-serif',
      textAlign: 'left',
      fontSize: '14px',
      margin: 0,
      outline: 'none',
      width: '100%',
      resize: 'none',
    })

  return div;

}



// WEBPACK FOOTER //
// ./src/client/component/textarea/textarea.js